













import Vue from 'vue';
import Component from 'vue-class-component';
import { Getter, Action } from 'vuex-class';

import FeedbackInterface from '@/@types/feedback';

@Component({})
export default class Feedback extends Vue {
  @Getter('getFeedback', { namespace: 'auth' })
  public feedback!: FeedbackInterface;
  @Action('setFeedback', { namespace: 'auth' }) public setFeedback: any;
}
